// @flow strict

/**
 * Footer content per language.
 *
 * Ported 1:1 from the main website footer data
 * (`_data/footer.yml` / `_data/en/footer.yml`). Product and company link
 * targets use the published clean-URL form (same as the blog's existing
 * `loc('_links_*')` keys) so they point at the live website pages.
 */
export const footerData = {
  de: {
    companyTitle: 'Unternehmen',
    productsTitle: 'Produkte',
    articleTitle: 'Wir lieben Kundenservice',
    newsletterUrl:
      'https://omq.us18.list-manage.com/subscribe?u=f843c42122fe1ecd9121296a0&id=aec1bf23e3',
    newsletterLabel: 'Zum Newsletter anmelden',
    homeUrl: '/de',
    euFunding: 'Gefördert durch die EU',
    copyrightSuffix: 'Alle Rechte vorbehalten.',
    company: [
      { title: 'Über uns', href: '/de/unternehmen/ueber-uns/' },
      { title: 'Jobs', href: '/de/unternehmen/jobs/' },
      { title: 'Impressum', href: '/de/unternehmen/impressum/' },
      { title: 'Datenschutz', href: '/de/unternehmen/datenschutz/' },
      { title: 'Kontakt', href: '/de/unternehmen/kontakt/' },
      { title: 'Support', href: '/de/support/' },
      { title: 'Lexikon', href: '/de/lexikon/' },
    ],
    products: [
      {
        title: 'KI Chatbot',
        href: '/de/produkte/chatbot/',
        imgSrc: '/images/icons/products/chatbot.svg',
        alt: 'OMQ Chatbot Icon',
      },
      {
        title: 'KI E-Mail Bot',
        href: '/de/produkte/reply/',
        imgSrc: '/images/icons/products/reply.svg',
        alt: 'OMQ Reply Icon',
      },
      {
        title: 'KI Voice Bot',
        href: '/de/produkte/voice-bot/',
        imgSrc: '/images/icons/products/voicebot.svg',
        alt: 'OMQ Voice Bot Icon',
      },
      {
        title: 'AI Agent',
        href: '/de/produkte/ai-agent/',
        imgSrc: '/images/icons/products/ai-agents.svg',
        alt: 'OMQ AI Agent Icon',
      },
      {
        title: 'Intelligente Hilfeseite',
        href: '/de/produkte/help/',
        imgSrc: '/images/icons/products/help.svg',
        alt: 'OMQ Help Icon',
      },
      {
        title: 'Smartes Kontaktformular',
        href: '/de/produkte/contact/',
        imgSrc: '/images/icons/products/contact.svg',
        alt: 'OMQ Contact Icon',
      },
      {
        title: 'Ticketsystem Assistent',
        href: '/de/produkte/assist/',
        imgSrc: '/images/icons/products/assist.svg',
        alt: 'OMQ Assist Icon',
      },
    ],
    articles: [
      {
        title: 'Was ist ein Chatbot? Funktionen einfach erklärt',
        href: '/de/was-ist-ein-chatbot/',
      },
      {
        title: 'Chatbot Anbieter und Chatbot Software im Vergleich',
        href: '/de/chatbot-anbieter/',
      },
      {
        title: 'First Level Support - Expertenwissen und Tipps',
        href: '/de/first-level-support/',
      },
      {
        title: 'ChatGPT im Kundenservice einsetzen',
        href: '/de/chatgpt-im-kundenservice-einsetzen/',
      },
      {
        title:
          'E-Mail Bot - So beantwortet man E-Mails im Kundenservice automatisch',
        href: '/de/blog/email-bot-emails-im-kundenservice-automatisch-beantworten/',
      },
    ],
  },
  en: {
    companyTitle: 'Company',
    productsTitle: 'Products',
    articleTitle: 'We love customer service',
    newsletterUrl:
      'https://omq.us18.list-manage.com/subscribe?u=f843c42122fe1ecd9121296a0&id=d691c68d19',
    newsletterLabel: 'Sign up for our newsletter',
    homeUrl: '/',
    euFunding: 'Co-funded by the EU',
    copyrightSuffix: 'All rights reserved.',
    company: [
      { title: 'About Us', href: '/company/about-us/' },
      { title: 'Jobs', href: '/company/jobs/' },
      { title: 'Imprint', href: '/company/imprint/' },
      { title: 'Privacy policy', href: '/company/data-security/' },
      { title: 'Contact', href: '/company/contact/' },
      { title: 'Support', href: '/support/' },
      { title: 'Lexicon', href: '/lexicon/' },
    ],
    products: [
      {
        title: 'AI Chatbot',
        href: '/products/chatbot/',
        imgSrc: '/images/icons/products/chatbot.svg',
        alt: 'OMQ Chatbot Icon',
      },
      {
        title: 'AI Email Bot',
        href: '/products/reply/',
        imgSrc: '/images/icons/products/reply.svg',
        alt: 'OMQ Reply Icon',
      },
      {
        title: 'AI Voice Bot',
        href: '/products/voice-bot/',
        imgSrc: '/images/icons/products/voicebot.svg',
        alt: 'OMQ Voice Bot Icon',
      },
      {
        title: 'AI Agent',
        href: '/products/ai-agent/',
        imgSrc: '/images/icons/products/ai-agents.svg',
        alt: 'OMQ AI Agent Icon',
      },
      {
        title: 'Intelligent Help Page',
        href: '/products/help/',
        imgSrc: '/images/icons/products/help.svg',
        alt: 'OMQ Help Icon',
      },
      {
        title: 'Smart Contact Form',
        href: '/products/contact/',
        imgSrc: '/images/icons/products/contact.svg',
        alt: 'OMQ Contact Icon',
      },
      {
        title: 'Ticket System Assistant',
        href: '/products/assist/',
        imgSrc: '/images/icons/products/assist.svg',
        alt: 'OMQ Assist Icon',
      },
    ],
    articles: [
      {
        title: 'What is a Chatbot? Functions simply explained',
        href: '/what-is-a-chatbot/',
      },
      {
        title: 'Chatbot Software and Chatbot Providers Compared',
        href: '/chatbot-provider/',
      },
      {
        title: 'First Level Support - Expert knowledge and tips',
        href: '/first-level-support/',
      },
      {
        title: 'Using ChatGPT in customer service',
        href: '/using-chatgpt-in-customer-service/',
      },
      {
        title:
          'Email Bot - How to Answer Customer Service Emails Automatically',
        href: '/blog/email-bot-answer-customer-service-emails-automatically/',
      },
    ],
  },
};

/**
 * Social media links shown in the brand column (same order/targets as the
 * main website footer).
 */
export const socialLinks = [
  {
    href: 'https://www.facebook.com/OMQ-741045522692005',
    title: 'OMQ Facebook',
    imgSrc: '/images/social-media/facebook.png',
    alt: 'Facebook icon',
  },
  {
    href: 'https://www.instagram.com/omq_ai/',
    title: 'OMQ Instagram',
    imgSrc: '/images/social-media/instagram.png',
    alt: 'Instagram icon',
  },
  {
    href: 'https://www.x.com/OMQ_AI',
    title: 'OMQ Twitter',
    imgSrc: '/images/social-media/x.png',
    alt: 'X icon',
  },
  {
    href: 'https://www.linkedin.com/company/omq',
    title: 'OMQ Linkedin',
    imgSrc: '/images/social-media/linkedin.png',
    alt: 'LinkedIn icon',
  },
];

/**
 * Rating badges shown below the newsletter call to action.
 */
export const ratingBadges = [
  { imgSrc: '/images/ratings/omr-badge.png', alt: 'omr rating badge' },
  { imgSrc: '/images/ratings/g2-badge.png', alt: 'g2 rating badge' },
  { imgSrc: '/images/ratings/google-badge.png', alt: 'google rating badge' },
];
